import shared from "../../../../src/shared.js";
import * as React from 'react';
export default {
  shared,
  React
};